export default __webpack_public_path__ + "static/media/reims13.13be11b4.jpg";